import React, { useContext, useEffect, useState } from "react";
import Fieldset from "../../components/fieldset/Fieldset";
import TextFieldCustom from "../../components/basic/TextFieldCustom";
import SelectCustom from "../../components/basic/SelectCustom";
import { ReportAccountantContext } from "../../context/ReportAccountantContext";
import api from "../../services/api";
import { UserContext } from "../../context/UserContext";
import { GlobalVariables } from "../../global";

const optionsMounth = [
  { id: 1, descricao: "Janeiro" },
  { id: 2, descricao: "Fevereiro" },
  { id: 3, descricao: "Março" },
  { id: 4, descricao: "Abril" },
  { id: 5, descricao: "Maio" },
  { id: 6, descricao: "Junho" },
  { id: 7, descricao: "Julho" },
  { id: 8, descricao: "Agosto" },
  { id: 9, descricao: "Setembro" },
  { id: 10, descricao: "Outubro" },
  { id: 11, descricao: "Novembro" },
  { id: 12, descricao: "Dezembro" },
];

const currentYear = new Date().getFullYear();
const optionsYear = [
  { descricao: currentYear.toString() },
  { descricao: (currentYear - 1).toString() },
  { descricao: (currentYear - 2).toString() },
];

const FilterReportAccountant = () => {
  const {
    cnpj,
    setCnpj,
    reason,
    setReason,
    status,
    setStatus,
    base,
    setBase,
    accountant,
    setAccountant,
    year,
    setYear,
    mounth,
    setMounth,
    optionsStatus,
    setOptionsStatus,
    optionsAccountants,
    setOptionsAccountants,
  } = useContext(ReportAccountantContext);
  const { user } = useContext(UserContext);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getDataStatus = async () => {
      try {
        setLoading(true);

        const { data: status } = await api.get("/motivoCancelamento/todos");

        if (status.success) {
          status.data.unshift({ Id: null, Descricao: "Ativo" });
          setOptionsStatus(status.data);
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getDataStatus();
  }, [setOptionsStatus]);

  useEffect(() => {
    const getDataAccountant = async () => {
      try {
        setLoading(true);

        const { data } = await api.get(
          `/promotor/todos/${GlobalVariables.TIPO_PROMOTOR_CONTADOR}`
        );

        if (data.success) {
          setOptionsAccountants(data.data);
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    if (user.IdTipoUsuario === GlobalVariables.ADM_QYON) {
      getDataAccountant();
    }
  }, [user, setOptionsAccountants]);

  const inputsFilter = [
    {
      component: (
        <TextFieldCustom
          autoFocus
          mask="cnpj"
          key="cnpj"
          label="CNPJ"
          lg={3}
          value={cnpj}
          setValue={setCnpj}
        ></TextFieldCustom>
      ),
    },
    {
      component: (
        <TextFieldCustom
          key="razao"
          label="Razão"
          lg={3}
          value={reason}
          setValue={setReason}
        ></TextFieldCustom>
      ),
    },
    {
      component: (
        <SelectCustom
          loading={loading}
          label="Status"
          keyObject="Descricao"
          lg={2}
          value={status}
          setValue={setStatus}
          key="select-status"
          optionsList={optionsStatus}
        ></SelectCustom>
      ),
    },
    {
      component: (
        <TextFieldCustom
          key="base"
          label="Nome de Acesso"
          lg={2}
          value={base}
          setValue={setBase}
        ></TextFieldCustom>
      ),
    },
  ];

  if (user.IdTipoUsuario === GlobalVariables.ADM_QYON) {
    inputsFilter.push({
      component: (
        <SelectCustom
          loading={loading}
          label="Contador"
          keyObject="Razao"
          lg={2}
          value={accountant}
          setValue={setAccountant}
          key="select-status"
          optionsList={optionsAccountants}
        ></SelectCustom>
      ),
    });
  }

  inputsFilter.push(
    {
      component: (
        <SelectCustom
          className="select-mounth"
          loading={false}
          label="Mês competência"
          lg={2}
          value={mounth}
          setValue={setMounth}
          key="select-mounth"
          optionsList={optionsMounth}
        />
      ),
    },
    {
      component: (
        <SelectCustom
          className="select-year"
          loading={false}
          label="Ano"
          lg={2}
          value={year}
          setValue={setYear}
          key="select-year"
          optionsList={optionsYear}
        />
      ),
    }
  );

  return (
    <div className="container-fieldset">
      <Fieldset inputs={inputsFilter} key="filter" />
    </div>
  );
};

export default FilterReportAccountant;
